import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { AccessLog } from '@/services/logsManagement/logsMangement.types';
import * as React from 'react';
import { getColumns } from './Column';

export const AccessLogsTable = ({ data }: { data: AccessLog[] }) => {
  const columns = React.useMemo(() => getColumns(), []);

  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'sn', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: 'Access Logs',
    },
    getRowId: (originalRow) => String(originalRow.sn),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <div>
      <DataTable table={table} className="rounded-t-none rounded-b-xl">
        <DataTableToolbar />
      </DataTable>
    </div>
  );
};
